// DO NOT MODIFY
// generated by process.js in the importer directory based on the downloaded google sheets excel file
export default [
  {
    "id": "MDA",
    "vimeo": "https://vimeo.com/366499461"
  },
  {
    "id": "Mythes",
    "vimeo": "https://vimeo.com/366499574"
  },
  {
    "id": "Epistemic_framing",
    "vimeo": "https://vimeo.com/366500076"
  },
  {
    "id": "Horseless_carriage",
    "vimeo": "https://vimeo.com/366500020"
  },
  {
    "id": "Ruleset",
    "vimeo": "https://vimeo.com/366500058"
  },
  {
    "id": "Leercurves",
    "vimeo": "https://vimeo.com/366499983"
  },
  {
    "id": "Playertypes_Bartle",
    "vimeo": "https://vimeo.com/366499950"
  },
  {
    "id": "Vitruvius",
    "vimeo": "https://vimeo.com/366499825"
  },
  {
    "id": "SDT",
    "vimeo": "https://vimeo.com/366499633"
  },
  {
    "id": "HKU_Playful_Design_Canvas",
    "vimeo": "https://vimeo.com/366499623"
  },
  {
    "id": "Deck_of_lenses",
    "vimeo": "https://vimeo.com/366499266"
  },
  {
    "id": "Direct_Feedback_Loop",
    "vimeo": "https://vimeo.com/366499299"
  },
  {
    "id": "Wat_zijn_games_",
    "vimeo": "https://vimeo.com/366499283"
  },
  {
    "id": "Feedback_on_state",
    "vimeo": "https://vimeo.com/366499334"
  },
  {
    "id": "Mastery",
    "vimeo": "https://vimeo.com/366499390"
  },
  {
    "id": "ShowMeTheWay",
    "vimeo": "https://vimeo.com/384483244"
  },
  {
    "id": "Nieuwsgierigheid",
    "vimeo": "https://vimeo.com/366499256"
  },
  {
    "id": "CelebrateVictory",
    "vimeo": "https://vimeo.com/366499243"
  },
  {
    "id": "applied_Serious_SIM",
    "vimeo": "https://vimeo.com/366499228"
  },
  {
    "id": "Ruleset_Kolb",
    "vimeo": "https://vimeo.com/366500058"
  },
  {
    "id": "Canvas-2",
    "vimeo": "https://vimeo.com/666939589"
  },
  {
    "id": "Paper_Prototype",
    "vimeo": "https://vimeo.com/666943068"
  },
  {
    "id": "Prototype_Canvas",
    "vimeo": "https://vimeo.com/667211070"
  },
  {
    "id": "Templates",
    "vimeo": "https://vimeo.com/666943743"
  },
  {
    "id": "Gamescope",
    "vimeo": "https://vimeo.com/666949988"
  },
  {
    "id": "Productietips",
    "vimeo": "https://vimeo.com/666951386"
  },
  {
    "id": "Prop_Kwaliteiten",
    "vimeo": "https://vimeo.com/666946904"
  },
  {
    "id": "Huizinga",
    "vimeo": "https://vimeo.com/666952600"
  },
  {
    "id": "Erasmus",
    "vimeo": "https://vimeo.com/666953306"
  },
  {
    "id": "Playloop_Canvas",
    "vimeo": "https://vimeo.com/668628290"
  },
  {
    "id": "Mechanics_Deck",
    "vimeo": "https://vimeo.com/668628847"
  },
  {
    "id": "MDA_Canvas",
    "vimeo": "https://vimeo.com/668629201"
  },
  {
    "id": "Denkmodel_Canvas",
    "vimeo": "https://vimeo.com/668629800"
  },
  {
    "id": "Aesthetics_Deck",
    "vimeo": "https://vimeo.com/668630056"
  },
  {
    "id": "Epic_Epistemic_Canvas",
    "vimeo": "https://vimeo.com/669491385"
  },
  {
    "id": "Contextual_Design_Canvas",
    "vimeo": "https://vimeo.com/618952647"
  },
  {
    "id": "Dynamics_Deck",
    "vimeo": "https://vimeo.com/668629496"
  }
]
